import consts from 'constants/url';
import kfetch from '../util/kfetch';

export const postSaveNotes = (payload) => (dispatch) => kfetch(consts.get('SAVE_NOTES'), payload, 'POST')
    .then((response) => {
        dispatch({
            type: 'INIT_USER_NOTES_DATA',
            payload: payload
        });
    });